import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as params from '../constants/wix-params';
import { TEXT_ALIGNMENT_CENTER } from '../constants/text-alignment';
import withAppSettings from './with-app-settings';
import getDisplayName from '../services/get-display-name';

const DEFAULT_ALIGNMENT = TEXT_ALIGNMENT_CENTER;

export default function withCategoryTextAlignment(WrappedComponent) {
  const Wrapper = class extends Component {
    static displayName = `WithCategoryTextAlignment(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      categoryTextAlignment: PropTypes.number,
    };

    static defaultProps = {
      categoryTextAlignment: DEFAULT_ALIGNMENT,
    };

    render() {
      const { categoryTextAlignment, ...otherProps } = this.props;
      return <WrappedComponent categoryTextAlignment={categoryTextAlignment} {...otherProps}/>;
    }
  };

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return withAppSettings({
    categoryTextAlignment: params.CATEGORY_TEXT_ALIGNMENT_PATH,
  })(Wrapper);
}



// WEBPACK FOOTER //
// ./app/hoc/with-category-text-alignment.js